module.exports = __webpack_public_path__ + "assets/rossette-pinpoint.2b6360f9.svg";